import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import * as styles from "./CardContent.module.scss";

const CardContent = ({ className, style, children, checklist }) =>
	checklist.length > 1 ? (
		<ul className={cx(styles.checklist, className)}>
			{checklist.map(list => (
				<li key={list.id}>{list.item}</li>
			))}
		</ul>
	) : (
		<div className={cx(className)} style={style}>
			{children}
		</div>
	);

CardContent.propTypes = {
	checklist: PropTypes.array,
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
	className: PropTypes.string,
	style: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
};

CardContent.defaultProps = {
	children: undefined,
	checklist: [],
	className: "",
	style: {},
};

export default CardContent;
export { CardContent };
